import jwtDecode from 'jwt-decode';

export const setJWT = (token) => sessionStorage.setItem('jwt', token);
export const getJWT = () => sessionStorage.getItem('jwt');
export const removeJWT = () => sessionStorage.removeItem('jwt');

export const decodeJWT = (token) => jwtDecode(token);